import React from 'react';
import Resources from '../../../Admin/Resources';

export default function Resource() {
  return <Resources />;
}
